import { ReactNode, useMemo } from "react";
import { alpha, ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import componentsOverride from "theme//overrides";
import useAppTheme from "hooks/useAppTheme";

type Props = {
  children: ReactNode;
};

export default function ThemeFontAndColorPresets({ children }: Props) {
  const defaultTheme = useTheme();
  const { primaryColourSet, primaryFont } = useAppTheme();
  const themeOptions = useMemo(
    () => ({
      ...defaultTheme,
      typography: {
        ...defaultTheme.typography,
        fontFamily: primaryFont,
      },
      palette: {
        ...defaultTheme.palette,
        primary: {
          contrastText: primaryColourSet
            ? primaryColourSet.contrastText
            : defaultTheme.palette.primary.contrastText,
          dark: primaryColourSet ? primaryColourSet.dark : defaultTheme.palette.primary.dark,
          darker: primaryColourSet ? primaryColourSet.darker : defaultTheme.palette.primary.darker,
          light: primaryColourSet ? primaryColourSet.light : defaultTheme.palette.primary.light,
          lighter: primaryColourSet
            ? primaryColourSet.lighter
            : defaultTheme.palette.primary.lighter,
          main: primaryColourSet ? primaryColourSet.main : defaultTheme.palette.primary.main,
        },
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(
          primaryColourSet ? primaryColourSet.main : defaultTheme.palette.primary.main,
          0.24
        )}`,
      },
    }),
    [primaryColourSet, primaryFont, defaultTheme]
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
